<template>
  <div>
    <template v-if="isReadInfo"> </template>
    <template v-else>
      <v-alert v-if="isReadonly" text type="warning">
        <div class="black--text">
          Mohon maaf, hanya informasi umum yang dapat diubah karena terdapat responden yang telah mengisi kuesioner.
          Terima kasih atas pemahaman Anda.
        </div>
      </v-alert>
      <v-alert v-else text type="info">
        <div class="black--text">
          Setelah Anda selesai mengisi informasi umum, Anda dapat membuat pertanyaan kuesioner pada tab Kuesioner
          Masook.
        </div>
      </v-alert>
    </template>
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-card class="pa-3">
        <v-card-text class="black--text">
          <span class="text-h6 font-weight-regular"> Informasi Umum </span>
          <div class="mt-2">
            <span class="grey--text">Judul Kuesioner</span>
            <v-text-field
              dense
              single-line
              outlined
              :readonly="isReadInfo"
              counter="40"
              label="Judul Kuesioner"
              hint="Isikan judul kuesioner"
              v-model="form.nama"
              data-vv-name="nama"
              data-vv-as="Judul Kuesioner"
              v-validate="'required|max:40'"
              :error-messages="errors.collect('form.nama')"
            ></v-text-field>
            <span class="grey--text">Deskripsi Kuesioner</span>
            <v-textarea
              dense
              single-line
              outlined
              rows="1"
              :readonly="isReadInfo"
              counter="100"
              label="Deskripsi Kuesioner"
              hint="Isikan deskripsi kuesioner"
              v-model="form.deskripsi"
              data-vv-name="deskripsi"
              data-vv-as="Deskripsi Kuesioner"
              v-validate="'required|max:100'"
              :error-messages="errors.collect('form.deskripsi')"
            ></v-textarea>
            <span class="grey--text">Tampilan Kuesioner Pada Pengguna</span>
            <v-radio-group
              v-model="form.is_wizard"
              row
              :readonly="isReadInfo"
              data-vv-name="is_wizard"
              data-vv-as="Tampilan Kuesioner"
              v-validate="'required'"
              :error-messages="errors.collect('form.is_wizard')"
            >
              <v-radio class="caption" label="Tampilkan Semua" :value="0"></v-radio>
              <v-radio class="caption" label="Tampilkan Satu Per Satu" :value="1"></v-radio>
            </v-radio-group>
          </div>
          <span class="text-h6 font-weight-regular">
            Waktu Pengisian <v-icon color="blue" @click="showMessage">mdi-information</v-icon></span
          >
          <div class="mt-2">
            <span class="grey--text"> Berapa Banyak pengguna harus melakukan pengisian kuesioner ? </span>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-radio-group
                  v-model="form.k_tipe_pengisian"
                  row
                  :readonly="isReadInfo"
                  data-vv-name="periode"
                  data-vv-as="Periode Pengisian"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.periode')"
                >
                  <v-radio v-for="(op, o) in M_PERIOD" :key="o" :label="op.value" :value="op.key">
                    <template v-slot:label>
                      {{ op.value }}
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col cols="12" md="6" sm="12" class="py-0">
                    <span class="grey--text"> Waktu Kuesioner Mulai Berlaku</span>
                    <m-date-time-picker
                      v-model="form.wkt_mulai"
                      prepend-inner-icon="mdi-calendar"
                      placeholder="Waktu Berlaku"
                      :readonly="isReadInfo"
                      :min="MIN_DATE | toSF"
                      data-vv-name="wkt_mulai"
                      data-vv-as="Waktu Mulai"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.wkt_mulai')"
                    />
                  </v-col>
                  <v-col cols="12" md="6" sm="12" class="py-0">
                    <span class="grey--text"> Waktu Kuesioner Selesai Berlaku</span>
                    <m-date-time-picker
                      v-model="form.wkt_selesai"
                      prepend-inner-icon="mdi-calendar"
                      placeholder="Waktu Selesai"
                      :readonly="isReadInfo"
                      :min="form.wkt_mulai ? form.wkt_mulai : MIN_DATE | toSF"
                      :minTime="rulesTime"
                      data-vv-name="wkt_selesai"
                      data-vv-as="Waktu Selesai"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.wkt_selesai')"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="[3, 4].includes(Number(form.k_tipe_pengisian))" cols="12" md="6" sm="12">
                <span class="grey--text"> Waktu Kuesioner Mulai Ditayangkan</span>
                <v-row dense no-gutters>
                  <v-col cols="12" md="8" sm="6" class="py-0">
                    <v-select
                      v-model="form.hari_mulai"
                      :items="itemHari"
                      :readonly="isReadInfo"
                      :placeholder="`- Pilih ${Number(form.k_tipe_pengisian) === 3 ? 'Hari' : 'Tanggal'} -`"
                      item-value="value"
                      item-text="text"
                      item-disabled="disabled"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4" sm="6" class="py-0">
                    <m-timepicker v-model="form.jam_mulai" :disabled="isReadInfo" outlined dense></m-timepicker>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="[3, 4].includes(Number(form.k_tipe_pengisian))" cols="12" md="6" sm="12">
                <span class="grey--text"> Waktu Kuesioner Selesai Ditayangkan</span>
                <v-row dense no-gutters>
                  <v-col cols="12" md="8" sm="6" class="py-0">
                    <v-select
                      v-model="form.hari_selesai"
                      :items="itemHariSelesai"
                      :readonly="isReadInfo"
                      :placeholder="`- Pilih ${Number(form.k_tipe_pengisian) === 3 ? 'Hari' : 'Tanggal'} -`"
                      item-value="value"
                      item-text="text"
                      item-disabled="disabled"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4" sm="6" class="py-0">
                    <m-timepicker v-model="form.jam_selesai" :disabled="isReadInfo" outlined dense></m-timepicker>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="form.k_tipe_pengisian === 2" cols="12" md="12" sm="12">
                <v-row>
                  <v-col cols="12" md="6" sm="6" class="py-0">
                    <span class="grey--text"> Waktu Kuesioner Mulai Ditayangkan</span>
                    <div>
                      <m-timepicker v-model="form.jam_mulai" :disabled="isReadInfo" outlined dense></m-timepicker>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="6" class="py-0">
                    <span class="grey--text"> Waktu Kuesioner Selesai Ditayangkan</span>
                    <div>
                      <m-timepicker v-model="form.jam_selesai" :disabled="isReadInfo" outlined dense></m-timepicker>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-if="form.k_tipe_pengisian" cols="12" md="12" sm="12">
                <v-alert type="info" text>
                  <span class="black--text">
                    {{ getDeepObj(M_PERIOD.find((s) => s.key === Number(form.k_tipe_pengisian)) || {}, 'desc') }}
                  </span>
                </v-alert>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="mt-3">
        <v-toolbar flat>
          <v-toolbar-title class="title font-weight-normal black--text my-3">Target Pengisian</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div> Siapa saja yang akan menjadi target pengisian kuesioner ? </div>
          <v-radio-group
            v-model="form.is_responden"
            row
            @change="changeUser"
            :readonly="isReadInfo"
            data-vv-name="responden"
            data-vv-as="Target Pengisian"
            v-validate="'required'"
            :error-messages="errors.collect('form.responden')"
          >
            <v-radio label="Semua Anggota" :value="0"></v-radio>
            <v-radio label="Sebagian Anggota" :value="1"></v-radio>
          </v-radio-group>
        </v-card-text>
        <m-card-list
          class="mx-1 mt-n5"
          :title="`<div class='subtitle-1'><span class='primary--text'>${
            selected || 0
          }</span> Anggota Terpilih dari <span class='primary--text'>${deff.total || 0}</span></div>`"
          :items="items"
          :page="page"
          :search="false"
          @search="onSearch"
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @refresh="load()"
          footer
        >
          <template v-slot:filter>
            <div class="mx-4 mt-2">
              <v-text-field
                v-model="textSearch"
                dense
                outlined
                placeholder="Cari Nama Responen"
                :readonly="[null, 0, undefined, ''].includes(form.is_responden) || isReadInfo"
                @keyup.enter="onSearch"
              >
                <template v-slot:prepend> Pencarian </template>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-magnify</v-icon>
                </template>
              </v-text-field>
              <v-select
                v-model="selectedGroup"
                outlined
                dense
                small-chips
                deletable-chips
                :items="groups"
                placeholder="Filter Berdasarkan Group"
                item-text="nama"
                item-value="group_id"
                multiple
                :readonly="[null, 0, undefined, ''].includes(form.is_responden) || isReadInfo"
                @change="filterGroup"
              >
                <template v-slot:prepend-inner>
                  <v-icon>mdi-filter</v-icon>
                </template>
                <template v-slot:prepend> Group &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </template>
              </v-select>
            </div>
          </template>
          <template v-slot:action_tools>
            <template>
              <v-btn class="mx-2" color="primary" small outlined rounded @click="showUsers">
                <span class="text-capitalize"> Lihat Target Terpilih</span>
                <v-icon small right>mdi-view-list</v-icon>
              </v-btn>
            </template>
          </template>
          <template v-slot:header>
            <tr>
              <td>
                <v-checkbox
                  class="text-center ml-md-9"
                  v-model="is_pilih_semua"
                  :true-value="1"
                  :false-value="0"
                  :readonly="[null, 0, undefined, ''].includes(form.is_responden) || isReadInfo"
                  @click="onSelectAll"
                />
              </td>
              <td style="width: 300px"><span class="ml-5"> Nama Anggota</span></td>
              <td>Peran</td>
              <td>Group</td>
              <td>Status Anggota</td>
            </tr>
          </template>
          <template v-slot:items="{ item }">
            <tr>
              <td>
                <v-checkbox
                  v-model="select[Number(item.user_id)]"
                  class="ml-md-5"
                  color="primary"
                  :readonly="[null, 0, undefined, ''].includes(form.is_responden) || isReadInfo"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </td>
              <td>
                <v-row wrap class="pt-3">
                  <v-col cols="2" align="center" justify="center">
                    <v-avatar :size="40" color="grey lighten-4">
                      <v-img
                        :src="item.file_foto ? item.file_foto : item.gender == 'P' ? 'img/cewek.png' : 'img/cowok.png'"
                        alt="avatar"
                      />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10" class="mt-1 pt-1">
                    <p class="subtitle font-weight-bold my-0 py-0">
                      <router-link
                        class="ok"
                        :to="{
                          name: 'user.detail',
                          params: {
                            organisasi_id: organisasi_id,
                            user_id: item.user_id,
                          },
                        }"
                        >{{ item.nama | toTitleCase }}</router-link
                      >
                    </p>
                    <p class="grey--text caption">
                      {{ pVal(item, 'email') }} <br />
                      {{ (item && item.no_pegawai) || 'Belum tersedia nomor pegawai' }}
                    </p>
                  </v-col>
                </v-row>
              </td>
              <td>{{ pVal(item, 'role') }}</td>
              <td>
                <template v-if="item.groups_member && item.groups_member.length">
                  <div v-for="(grup, g) in item.groups_member" :key="g">
                    {{ getDeepObj(grup, 'groups.nama') }}
                  </div>
                </template>
                <template v-else> - </template>
              </td>
              <td>
                <v-chip small outlined :color="item.is_aktif == 1 ? 'info' : 'red'">{{
                  item.is_aktif == 1 ? 'Aktif' : 'Tidak Aktif'
                }}</v-chip>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-card>
    </v-form>
    <MsgPetunjuk ref="msgpopup" :users="users" @delete="onDeleteSelected" />
  </div>
</template>
<script>
import { toSD, toTimeF } from '@/tools'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    MDateTimePicker: () => import('@/components/MDateTimePicker.vue'),
    MsgPetunjuk: () => import('./MsgPetunjuk.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    isReadInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: null,
      cp: 1,
      textSearch: '',
      is_pilih_semua: 0,
      form: {},
      MIN_DATE: new Date(),
      items: [],
      debouce: null,
      selectedGroup: [],
      select: {},
      deff: {
        is_semua: 1,
        anggota: 1,
        total: 0,
      },
      headers: [
        { text: '', align: 'right', sortable: false },
        { text: 'Nama Anggota', align: 'left', value: 'nama' },
        { text: 'Peran', align: 'left', value: 'role' },
        { text: 'Group', align: 'left', value: 'group' },
        { text: 'Status Pengguna', align: 'left', value: 'is_aktif' },
      ],
      M_PERIOD: [
        {
          key: 1,
          value: '1x Tayang',
          desc: 'Jika Anda memilih tipe waktu kuesioner adalah Sekali Saja. Maka kuesioner tersebut. Nantinya akan dikirimkan hanya sekali saja pada waktu yang Anda tentukan',
        },
        {
          key: 2,
          value: 'Harian',
          desc: 'Jika Anda memilih tipe waktu kuesioner adalah Berulang Setiap Waktu. Maka kuesioner tersebut. Nantinya akan dikirimkan, sesuai dengan waktu yang Anda pilih nantinya dalam pengaturan',
        },
        {
          key: 3,
          value: 'Mingguan',
          desc: 'Jika Anda memilih tipe waktu kuesioner adalah Berulang Setiap Waktu. Maka kuesioner tersebut. Nantinya akan dikirimkan, sesuai dengan waktu yang Anda pilih nantinya dalam pengaturan',
        },
        {
          key: 4,
          value: 'Bulanan',
          desc: 'Jika Anda memilih tipe waktu kuesioner adalah Berulang Setiap Waktu. Maka kuesioner tersebut. Nantinya akan dikirimkan, sesuai dengan waktu yang Anda pilih nantinya dalam pengaturan',
        },
      ],
    }
  },
  created() {
    this.load()
  },
  computed: {
    selected() {
      let count = 0

      Object.keys(this.select).forEach((item) => {
        if (this.select[item] || this.select[item] === 1) {
          count++
        }
      })

      return count
    },

    itemHari() {
      const weekly = [
        {
          value: 1,
          text: 'SENIN',
        },
        {
          value: 2,
          text: 'SELASA',
        },
        {
          value: 3,
          text: 'RABU',
        },
        {
          value: 4,
          text: 'KAMIS',
        },
        {
          value: 5,
          text: 'JUMAT',
        },
        {
          value: 6,
          text: 'SABTU',
        },
        {
          value: 7,
          text: 'MINGGU',
        },
      ]
      let monthly = []
      for (let i = 1; i <= 31; i++) {
        monthly.push({ value: i, text: i })
      }

      return Number(this.getDeepObj(this.form, 'k_tipe_pengisian')) === 3 ? weekly : monthly
    },

    itemHariSelesai() {
      const weekly = [
        {
          value: 1,
          text: 'SENIN',
        },
        {
          value: 2,
          text: 'SELASA',
        },
        {
          value: 3,
          text: 'RABU',
        },
        {
          value: 4,
          text: 'KAMIS',
        },
        {
          value: 5,
          text: 'JUMAT',
        },
        {
          value: 6,
          text: 'SABTU',
        },
        {
          value: 7,
          text: 'MINGGU',
        },
      ]
      let monthly = []
      for (let i = 1; i <= 31; i++) {
        monthly.push({
          value: i,
          text: `${i} ${
            Number(this.getDeepObj(this.form, 'hari_mulai') || 0) <= Number(i) ? '' : ' - Bulan Berikutnya'
          }`,
        })
      }

      return Number(this.getDeepObj(this.form, 'k_tipe_pengisian')) === 3 ? weekly : monthly
    },
    rulesTime() {
      const wkt_mulai = toSD(this.getDeepObj(this.form, 'wkt_mulai'))
      const wkt_selesai = toSD(this.getDeepObj(this.form, 'wkt_selesai'))
      const time_mulai = toTimeF(this.getDeepObj(this.form, 'wkt_mulai'))

      if (wkt_mulai === wkt_selesai) {
        if (time_mulai) {
          return time_mulai
        }
      } else {
        return ''
      }
    },
  },
  methods: {
    reset() {
      this.$validator.reset()
      this.form = {}
      this.select = {}
      this.textSearch = ''
      this.selectedGroup = []
      this.is_pilih_semua = 0
    },

    initForm(obj, responden) {
      if (obj) {
        this.form = obj || {}
        if (obj && obj.is_responden === 0) {
          this.is_pilih_semua = 1
        }
      }

      if (responden.length > 0) {
        responden.forEach((key) => {
          this.$set(this.select, key, 1)
        })
      }
    },

    async getValue() {
      const validator = await this.$validator.validateAll('form')
      if (validator) {
        let params = JSON.parse(JSON.stringify(this.form))
        let selected = []

        Object.keys(this.select).forEach((item) => {
          if (this.select[item] || this.select[item] === 1) {
            selected.push(Number(item))
          }
        })

        if (this.form.is_responden === 1) {
          this.$set(params, 'ids', selected)
        }

        return params
      } else {
        return false
      }
    },

    load() {
      this.$store
        .dispatch('kuesioner/getUsers', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            limit: 5,
            keyword: this.textSearch,
            group_id: this.selectedGroup || [],
            order_by_nama: true,
            is_aktif: 1,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
          this.deff.total = res.data.total || 0
        })
        .catch((e) => e)
    },

    changeUser(value) {
      if (value === 0) {
        this.select = {}
        const users = this.users.map((s) => s.user_id) || []
        users.forEach((key) => {
          this.$set(this.select, key, 1)
        })
      }
    },

    onSearch() {
      this.page = 1
      this.cp = 1
      this.load()
    },

    onDeleteSelected(item) {
      this.$delete(this.select, item.user_id)
    },

    showMessage() {
      this.$refs.msgpopup.open(
        {
          selected: this.select,
        },
        'petunjuk'
      )
    },
    showUsers() {
      if (this.selected === 0) {
        this.$error('Belum ada target anggota terpilih')
        return
      }
      this.$refs.msgpopup.open(
        {
          k_tipe_pengisian: Number(this.getDeepObj(this.form, 'k_tipe_pengisian')),
          selected: this.select,
        },
        'user'
      )
    },
    onSelectAll() {
      if (this.is_pilih_semua === 1) {
        this.select = {}
        const users = this.users.map((s) => s.user_id) || []
        users.forEach((key) => {
          this.$set(this.select, key, 1)
        })
      } else if (this.is_pilih_semua === 0) {
        this.select = {}
      }
    },
    selectGroup(item) {
      this.$store.dispatch('grup/getMember', item.group_id).then(({ data }) => {
        const members = (data && data.members) || []
        const users = this.users.map((s) => s.user_id) || []
        members.forEach((item) => {
          if (users.includes(Number(item.user_id))) {
            this.$set(this.select, item.user_id, 1)
          }
        })
      })
    },
    filterGroup() {
      clearTimeout(this.debouce)
      this.debouce = setTimeout(() => {
        this.load()
      }, 1000)
    },
  },
  watch: {
    value: 'initForm',
    form: {
      handler(item) {
        this.$emit('info', item)
      },
      deep: true,
    },
  },
}
</script>
